import React from 'react';
import { styles } from './styles';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { getResultsUrlForBib } from '../../utils/resultsHelpers';
import { getCourseDetail } from '../../utils/ERPUtil';
import { suggestionText } from './suggestionText';

/**
 * results - render:
 *  {bib} {name}
 *  {gender} {age} | {courseName}
 */

export function TypeaheadOption({
  option,
  value,
  isFocused,
  isHovered,
  isSelected,
  ignorePrivacySettings,
  isKiosk = false,
  eventMetadata,
}: {
  eventMetadata: {
    eventCourseMetadata: any[]
  }
  ignorePrivacySettings: boolean
  isFocused: boolean
  isHovered: boolean
  isKiosk: boolean
  isSelected: boolean
  option: {
    age: number
    bib: string
    entryId: number
    eventCourseId: number
    eventId: number
    gender: string
    masterEventId: number
    showPersonalData?: boolean
    ShowPersonalData?: boolean
  }
  value: string
}) {

  const {
    age, bib, entryId, eventCourseId, eventId, gender, masterEventId
  } = option;

  const notPrivate = ignorePrivacySettings || option.ShowPersonalData || option.showPersonalData;
  const userLink = getResultsUrlForBib(eventId, eventCourseId, bib, masterEventId, entryId);
  const eventCourseDetail = getCourseDetail(eventCourseId, eventMetadata);
  const { eventCourseName } = eventCourseDetail;

  if (!!_.size(option) && notPrivate) {
    return (
      <Link to={userLink}>
        <div
          className='row mx-0 dropdown-option'
          //@ts-ignore
          style={styles.typeaheadOptionContainer(isFocused, isHovered, isSelected, isKiosk)}
        >
          <div className='col-12 px-0 suggestion-text'>
            {suggestionText({ searchQuery: value, res: option, isFocused })}
          </div>
          <div className='col-12 px-0' style={styles.typeaheadOptionSpanWrap}>
            <span style={styles.typeaheadOptionGender}>
              {`${gender} ${age || ''}`}
            </span>
            <span>
              {eventCourseName}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return null;
}
